/*
 * Attach a UI flow to a form.
 * A UI Flow being - essentially - a paged wizard
 */

import { validate } from '../utils/formUtils';
import _forEach from 'lodash/forEach';

// Helper function which makes the copy of the slide and takes its real height independently on parent's height
// We need this for correct work of slider in case of the slides with different height (see WYN-6806)
function _calcActualSlideHeight(slide) {
  let result = slide.outerHeight();
  // We MUST remember the current width here - otherwise we get an error in case of several columns in the page
  let currentSlideWidth = slide.outerWidth();
    let nCopy = slide.clone();
    nCopy.css({
      position:   'absolute',
      visibility: 'hidden',
      display:    'block !important',
      width:      `${currentSlideWidth}px`
    });
    nCopy.appendTo('body');
    result = nCopy.outerHeight();
    nCopy.remove();
  return result;
};

export default (function(d, $, _) {
  'use strict';

  var config = {
      wrapper:      '.xFormPages',
      module:       '.xComponent',
      next:         '.xActionNext',
      prev:         '.xActionPrevious',
      disable:      'xDisabled xHidden',
      progress:     '.xMetaProgressBar',
      progressPage: '.xProgressPage',
      validate:     false,
      plugin:       {
        timeout:          0, // prevent auto-start
        allowWrap:        false, // prevent looping
        slides:           'div.xFormPage', // slide selector
        log:              false, // no console.logging
        fx:               'ScrollVert', // transition
        pauseOnHover:     true, // pause on hover
        pagerTemplate:    '<li class="xPagerIcon"><span></span></li>', // lis for pager
        pagerActiveClass: 'activeSlide', // active slide class
      },
    },
    flowCache = {},
    flowCount = 0,
    // Flow class
    Flow = function(el, options) {
      _.extend(this, options);
      this.config = $.extend(true, {}, config, this.config); // deep merge config object
      this.fid = ++flowCount;
      this.form = el;
      this.$form = $(this.form);
      this.formId = el.id;
      this.$el = $(this.config.wrapper, this.form);
      this.$module = this.$el.parents(this.config.module);
      this.model = NGX.App.Components.get(this.$module.attr('id'));
      this.percent = 0;
      this.$progressBar = this.$module.find(config.progress);
      this.$progressPage = this.$module.find(config.progressPage);
      this.form.setAttribute('data-flow', this.fid);
      // initialise cycle2
      initCycle2.call(this);
      // update button classes
      updateUI.call(this);
      // cycle2 bugfix - does not auto-size hidden elements correctly
      if (this.config.plugin.autoHeight === 'container' && this.model) {
        this.model.on(
          'change:viewed',
          function() {
            autoSize.call(this);
          },
          this
        );
      }
      return this;
    },

    // resize the first slide on display if autosize is configured
    autoSize = function() {
      var height = $('.cycle-slide-active', this.$el).outerHeight();
      if (height === 0) {
        height = _calcActualSlideHeight($('.cycle-slide-active', this.$el));
      }
      this.$el.height(height + 'px');
      return height;
    },
    // setup cycle2 plugin
    initCycle2 = function() {
      this.$el.cycle(this.config.plugin).on(
        'cycle-after',
        $.proxy(function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
          updateUI.call(this);
          // TODO: pass these as a mapped object
          NGX.App.Events.trigger('flow:after', this, event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag);
          NGX.App.Events.trigger(
            'flow:after:' + this.formId,
            this,
            event,
            optionHash,
            outgoingSlideEl,
            incomingSlideEl,
            forwardFlag
          );
        }, this)
      );

      /** WYN-6806. In case of hidden elements, the container mode does not resize correctly. */
      if (this.config.plugin.autoHeight === 'container') {
        let containerType = this.config.plugin.containerType;
        this.$el.cycle(this.config.plugin).on('cycle-before', function(event, optionHash, outgoingSlideEl, incoming, forwardFlag) {
          // Because of the layout and styles applied to the container, we need to calculate the actual slide height
          // in case of imageGalleries, but not in other cases (WYN-6806, WYN-6843)
          let h = containerType === 'gallery' ? _calcActualSlideHeight($(incoming)) : $(incoming).outerHeight();
          // Resizing the container
          let duration = optionHash.sync ? optionHash.speed / 2 : optionHash.speed;
          optionHash.container.animate( { height: h }, duration );
        });
      };

      // get length of slideshow
      this.length = this.$el.data('cycle.opts').slideCount;
      // trigger ready event
      NGX.App.Events.trigger('flow:ready', this);
    },
    // update ui with contextual classes (next/prev button disabled classes) and completion percentage
    updateUI = function() {
      var cnf = this.config,
        add = 'addClass',
        rem = 'removeClass',
        $d,
        $m,
        $f,
        pos;
      if (!cnf.plugin.allowWrap) {
        // get Flow data
        $d = this.$el.data('cycle.opts');
        $m = this.$module;
        $f = this.$form;
        // hide prev button if at index 0
        $f.find(cnf.prev)[$d.currSlide === 0 ? add : rem](cnf.disable);
        // hide next button if at index -1
        $f.find(cnf.next)[$d.currSlide + 1 >= $d.slideCount ? add : rem](cnf.disable);
        // get progress as percentage
        this.$progressPage.text($d.currSlide + 1);
        pos = parseInt(($d.currSlide + 1) / this.length * 100);
        // if (typeof pos === 'number' && pos > this.percent) { // TODO: [SG] Should going back decrease the percentage?
        if (typeof pos === 'number') {
          this.percent = pos;
          this.$progressBar.attr('data-ngx-progress', pos).css('width', pos + '%');
        }
      }
    },
    // Retrieve a Flow object
    getFlowById = function(id) {
      return flowCache[id] || false;
    },
    // Create a new instance of a Flow object
    createFlow = function(id, options) {
      var el = d.getElementById(id),
        evtTrigger = function(e, method, id) {
          e.stopPropagation();
          e.preventDefault();
          // Integration API, use action:{previous,next} (new) as well as flow:{prev,next} (legacy).
          // See WYN-3979 requirements for more details.
          const action = 'action:' + (method === 'prev' ? 'previous' : method);
          NGX.Analytics.trigger(action);

          NGX.App.Events.trigger('flow:' + method, id);
          NGX.App.Events.trigger('flow:' + method + ':' + id, id);
          NGX.App.Events.trigger('navigate:' + method + ':' + id, id);
        },
        flow;
      if (el) {
        flow = el.hasAttribute('data-flow') ? getFlowById(id) : (flowCache[id] = new Flow(el, options));

        // TODO [SG]: DRYIFY
        if (flow.$form) {
          flow.$form
            .on('click', config.next, function(e) {
              if (!$(this).hasClass('xDisabled')) evtTrigger(e, 'next', id);
            })
            .on('click', config.prev, function(e) {
              if (!$(this).hasClass('xDisabled')) evtTrigger(e, 'prev', id);
            });
        } else {
          flow.$module
            .on('click', config.next, function(e) {
              if (!$(this).hasClass('xDisabled')) evtTrigger(e, 'next', id);
            })
            .on('click', config.prev, function(e) {
              if (!$(this).hasClass('xDisabled')) evtTrigger(e, 'prev', id);
            });
        }

        // bind NGX.App.Events to flow control
        const _listeners = {};
        _listeners['flow:next:' + id] = function(id) {
          triggerTransition(id, 'next');
        };

        _listeners['flow:prev:' + id] = function(id) {
          triggerTransition(id, 'prev');
        };

        NGX.App.Events.on(_listeners);

        return flow;
      }
      return false;
    },
    // Trigger item transition
    triggerTransition = function(id, fn) {
      var obj = getFlowById(id),
        objConf,
        method;
      if (obj && _.isFunction(obj[fn])) {
        objConf = obj.config;
        // wrap obj[fn]() so it executes within the correct scope
        method = function() {
          obj[fn].call(obj);
        };
        // if a validation function is specified
        if (_.isFunction(objConf.validate)) {
          switch (objConf.validate.call(obj, fn)) {
            case true:
              // there is a success function to run
              if (_.isFunction(objConf.success)) {
                objConf.success.call(obj, method, fn);
              } else {
                // otherwise proceed
                method();
              }
              break;
            case false:
              // obj.validate doesn't return true and obj.fail() exists
              if (_.isFunction(objConf.fail)) {
                objConf.fail.call(obj, method, fn);
              }
              break;
            default:
              // a true/false value was not returned, do not proceed with callback
              return false;
          }
        } else {
          method();
        }
      }
    };

  // prototype Cycle2 methods

  /**
   * Skip directly to page #
   * @param {integer} indx - numeric index of slide
   */
  Flow.prototype.goto = function(indx) {
    this.$el.cycle('goto', indx);
  };

  /**
   * Skip to next page
   */
  Flow.prototype.next = function() {
    if (this.config.validate === true) {
      if (validate(this.form) === true) {
        this.$el.cycle('next');
      }
    } else this.$el.cycle('next');
  };

  /**
   * Skip to previous page
   */
  Flow.prototype.prev = function() {
    this.$el.cycle('prev');
  };

  /**
   * Resize wrapper dependant on configuration
   */
  Flow.prototype.autosize = function() {
    autoSize.call(this);
  };

  /**
   * Destroy the flow, keeping the markup in place
   */
  Flow.prototype.destroy = function() {
    log.debug('Destroying UIFlow ' + this.$el.attr('id'), 6);
    this.form.removeAttribute('data-flow');
    this.$el.cycle('destroy');
    delete flowCache[this.formId];
  };

  var $trans = $.fn.cycle.transitions;

  // Additional transitions and transition aliases
  $trans.scrollVert = {
    before: function(opts, curr, next, fwd) {
      opts.API.stackSlides(curr, next, fwd);
      var w = opts.container
        .css('overflow', 'hidden')
        .addClass('xTransitioning')
        .width();
      opts.cssBefore = { top: fwd ? w : -w, left: 0, opacity: 1, display: 'block', visibility: 'visible' };
      opts.cssAfter = { zIndex: opts._maxZ - 2, top: 0 };
      opts.animIn = { top: 0 };
      opts.animOut = { top: fwd ? -w : w };
    },
    after: function(opts) {
      opts.container.removeClass('xTransitioning');
    },
  };

  $trans.scrollHorz = {
    before: function(opts, curr, next, fwd) {
      opts.API.stackSlides(curr, next, fwd);
      var w = opts.container
        .css('overflow', 'hidden')
        .addClass('xTransitioning')
        .width();
      opts.cssBefore = { left: fwd ? w : -w, top: 0, opacity: 1, display: 'block', visibility: 'visible' };
      opts.cssAfter = { zIndex: opts._maxZ - 2, left: 0 };
      opts.animIn = { left: 0 };
      opts.animOut = { left: fwd ? -w : w };
    },
    after: function(opts) {
      opts.container.removeClass('xTransitioning');
    },
  };
  $trans.ScrollHorz = $trans.scrollHorz;
  $trans.ScrollUp = $trans.scrollVert;
  $trans.ScrollVert = $trans.scrollVert;

  // expose public methods
  return {
    create: createFlow,
    get:    getFlowById,
    flowCache,
    flowCount,
  };
})(document, $, _);
